module.exports = __webpack_public_path__ + "static/media/daily_active_users.cb017b85.svg";